import type { Opportunity } from '../components/OpportunityPageTypes';

export type OpportunityListFilters = {
  clientId?: string | null;
  clientIds?: string[];
  stageNames?: string[];
  productIds?: string[];
  minValue?: number | '';
  maxValue?: number | '';
  contactId?: string | null;
  ownerId?: string | null;
  opportunityId?: string | null;
};

export function hasActiveOpportunityFilters(filters: OpportunityListFilters): boolean {
  return Boolean(
    filters.clientId || filters.contactId || filters.ownerId || filters.opportunityId || filters.clientIds?.length || filters.stageNames?.length || filters.productIds?.length || typeof filters.minValue === 'number' || typeof filters.maxValue === 'number',
  );
}

export function filterOpportunities(
  opportunities: Opportunity[],
  filters: OpportunityListFilters,
): Opportunity[] {
  const { clientId, contactId, ownerId, opportunityId } = filters;
  return opportunities.filter((opp) => {
    if (opportunityId && opp.id !== opportunityId) {
      return false;
    }
    if (clientId && !opp.client_ids.includes(clientId)) {
      return false;
    }
    if (contactId && opp.contact_id !== contactId) return false;
    if (ownerId && opp.owner !== ownerId) return false;
    if (filters.clientIds?.length && !opp.client_ids.some(id=>filters.clientIds!.includes(id))) return false;
    if (filters.stageNames?.length) {
      const stage = opp.stages.find(stage=>!stage.finished_at) || opp.stages[0];
      if (!stage || !filters.stageNames.includes(stage.name)) return false;
    }
    if (filters.productIds?.length && !opp.products.some(product=>filters.productIds!.includes(product.productId))) return false;
    if (typeof filters.minValue === 'number' && opp.value < filters.minValue) return false;
    if (typeof filters.maxValue === 'number' && opp.value > filters.maxValue) return false;
    return true;
  });
}
